export default "__VITE_ASSET__T2Lzwj4p__"